import type { RouterProps } from 'wouter';
import { DashboardLayout } from 'components/Layout/DashboardLayout';
import { CatalogPage } from 'components/pages/payments/CatalogPage';
import { CreateInvoicePage } from 'components/pages/payments/CreateInvoicePage';
import { InvoiceDetailPage } from 'components/pages/payments/InvoiceDetailPage/index';
import { InvoicesListPage } from 'components/pages/payments/InvoicesListPage';
import { UserDetailPage } from 'components/pages/payments/UserDetailPage';
import { PaymentsHomePage } from 'components/pages/PaymentsHomePage/PaymentsHomePage';
import React, { Suspense } from 'react';
import { Route, Router, Switch } from 'wouter';
import { usePaymentsApiHttpClientContext } from 'wrappers/PaymentsApiAuthProvider';
import { PlatformEntityProvider } from 'wrappers/PlatformEntityProvider';

import { DecodedParamsRoute } from './DecodedParamsRoute';

export const PaymentsRouter = ({
  hook,
  base,
  workspaceId,
}: Partial<RouterProps> & { workspaceId: string }): ReturnType<
  typeof Router
> => {
  const { hasWorkspace } = usePaymentsApiHttpClientContext();
  if (!hasWorkspace) {
    return (
      <DashboardLayout>
        <>Loading...</>
      </DashboardLayout>
    );
  }
  return (
    <PlatformEntityProvider>
      <DashboardLayout>
        <Suspense fallback={<>Loading...</>}>
          <Router hook={hook} base={base} key={base}>
            <Switch>
              <DecodedParamsRoute path="/users/:externalId">
                {(params) => (
                  <UserDetailPage
                    workspaceId={workspaceId}
                    externalId={params.externalId}
                  />
                )}
              </DecodedParamsRoute>
              <DecodedParamsRoute path="/invoices/:invoiceId">
                {(params) => (
                  <InvoiceDetailPage
                    workspaceId={workspaceId}
                    invoiceId={params.invoiceId}
                  />
                )}
              </DecodedParamsRoute>
              <DecodedParamsRoute path="/invoices">
                <InvoicesListPage workspaceId={workspaceId} />
              </DecodedParamsRoute>
              <DecodedParamsRoute path="/catalog">
                <CatalogPage workspaceId={workspaceId} />
              </DecodedParamsRoute>
              <DecodedParamsRoute path="/create-invoice">
                <CreateInvoicePage workspaceId={workspaceId} />
              </DecodedParamsRoute>
              <DecodedParamsRoute path="/">
                <PaymentsHomePage />
              </DecodedParamsRoute>
              <Route />
            </Switch>
          </Router>
        </Suspense>
      </DashboardLayout>
    </PlatformEntityProvider>
  );
};
